// Global, server-synced setting controlling whether media lists include family-visible items.
// Cached in localStorage so gallery requests can use it synchronously.
export const SHOW_FAMILY_MEDIA_KEY = 'radish-show-family-media';

const DEFAULT_SHOW_FAMILY_MEDIA = true;

let _showFamilyMedia = (() => {
  const stored = localStorage.getItem(SHOW_FAMILY_MEDIA_KEY);
  return stored == null ? DEFAULT_SHOW_FAMILY_MEDIA : stored === 'true';
})();

export function getShowFamilyMedia(): boolean {
  return _showFamilyMedia;
}

export function setShowFamilyMedia(showFamilyMedia: boolean): void {
  _showFamilyMedia = !!showFamilyMedia;
  localStorage.setItem(SHOW_FAMILY_MEDIA_KEY, String(_showFamilyMedia));
}
